import gsap from 'gsap';

export default class {
    constructor(){
        
        const heroCatch = document.querySelector('.p-kawasakiworld__hero__catch')
        if(heroCatch){
            let str = ""
            let text = heroCatch.innerText.split("")

            text.forEach( (t,i) => {
                str += '<span class="js-text__animation">' + t + '</span>'
            })

            heroCatch.innerHTML = str
        }
        gsap.to(heroCatch,{
            opacity:1
        })
        if(window.innerWidth > 576){
            gsap.fromTo('.p-kawasakiworld__hero__catch .js-text__animation',{
                y:'100%',
            },{
                y:0,
                stagger: 0.05,
                delay :.3,
                duration:.7,
                ease:"Expo.easeOut"
            })
            
        }else{
            gsap.fromTo('.p-kawasakiworld__hero__catch .js-text__animation',{
                x:'-100%',
            },{
                x:0,
                stagger: 0.05,
                delay :.3,
                duration:.7,
                ease:"Expo.easeOut"
            })
            
        }

    }
}
